import React from 'react'

const MwCardWrapper = ({children}) => {
    return (
        <div className=' my-3  bg-slate-50 rounded-lg'>{children}</div>
    )
}

export default MwCardWrapper